import {KTIcon} from '../../../../_metronic/helpers'
import {Content} from '../../../../_metronic/layout/components/content'
import AssignPermissionForm from './modal/AssignPermissionForm'

const RoleManagement = () => {
  return (
    <Content>
      <div>
        <button
          type='button'
          className='btn btn-primary'
          data-bs-toggle='modal'
          data-bs-target='#kt_modal_1'
        >
          <KTIcon iconName='plus' className='fs-2' />
          Assign/Permission
        </button>
      </div>

      {/* <AssignPermissionForm /> */}
    </Content>
  )
}

export default RoleManagement
